import { render } from "./ItemTypesTab.vue?vue&type=template&id=64a631e5"
import script from "./ItemTypesTab.vue?vue&type=script&lang=js"
export * from "./ItemTypesTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__